<template>
	<div class="b2b container-fluid py-3">
		<router-view @childrenRoute="hideNonChildren" />
		<div class="row" v-if="!isChildRoute">
			<div class="col-md-12 mb-2">
				<h4>OVERVIEW B2B</h4>
			</div>

			<div class="col-md-12">
				<div class="row">
					<div class="col-md-12 mb-3">
						<el-card shadow="hover">
							<div slot="header">
								<h5 class="text-center m-0 px-2">SALES {{ year }}</h5>
							</div>
							<div>
								<BarChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="380" />
							</div>
						</el-card>
						<Loader v-if="loading.table"/>
					</div>
				</div>

				<div class="row">
					<div class="col-md-6 mb-3">
						<el-card shadow="hover">
							<div slot="header">
								<h5 class="text-center m-0 px-2">TOP 10 CUSTOMER YTD {{ year }}</h5>
							</div>
							<div>
								<table class="table-g" style="width:100%;">
									<thead>
										<tr class="border-bottom">
											<th class="pb-2">Customer Id</th>
											<th class="pb-2 px-3">Customer Name</th>
											<th class="text-center">Total</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="item in reportdata?.data?.top_ten_customer_ytd" :key="'ytd_'+item.CustomerID">
											<td class="py-2 align-top">{{ item.CustomerID }}</td>
											<td class="py-2 px-3">{{ item.CustomerName }}</td>
											<td class="py-2 align-top text-right">{{ formatNum(item.Total, 0) }}</td>
										</tr>
										<!--
										<tr class="border-top">
											<td class="pt-2 fw-bold" colspan="2">Total</td>
											<td class="text-center font-weight-bold">{{ formatNum(totalPegawaiByJabatan, 0) }}</td>
										</tr>
										-->
									</tbody>
								</table>
							</div>
						</el-card>
						<Loader v-if="loading.table"/>
					</div>

					<div class="col-md-6 mb-3">
						<el-card shadow="hover">
							<div slot="header">
								<h5 class="text-center m-0 px-2">TOP 10 CUSTOMER {{ (getMonthName(month)).toUpperCase() }} {{ year }}</h5>
							</div>
							<div>
								<table class="table-g" style="width:100%;">
									<thead>
										<tr class="border-bottom">
											<th class="pb-2">Customer Id</th>
											<th class="pb-2 px-3">Customer Name</th>
											<th class="text-center">Total</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="item in reportdata?.data?.top_ten_customer_month" :key="'month_'+item.CustomerID">
											<td class="py-2 align-top">{{ item.CustomerID }}</td>
											<td class="py-2 px-3">{{ item.CustomerName }}</td>
											<td class="py-2 align-top text-right">{{ formatNum(item.Total, 0) }}</td>
										</tr>
										<!--
										<tr class="border-top">
											<td class="pt-2 fw-bold" colspan="2">Total</td>
											<td class="text-center font-weight-bold">{{ formatNum(totalPegawaiByJabatan, 0) }}</td>
										</tr>
										-->
									</tbody>
								</table>
							</div>
						</el-card>
						<Loader v-if="loading.table"/>
					</div>
				</div>

				<div class="row">
					<div class="col-md-6 mb-3">
						<el-card shadow="hover">
							<div slot="header">
								<h5 class="text-center m-0 px-2">TOP 10 ITEM YTD {{ year }}</h5>
							</div>
							<div>
								<table class="table-g" style="width:100%;">
									<thead>
										<tr class="border-bottom">
											<th class="pb-2">Item Id</th>
											<th class="pb-2 px-3">Item Name</th>
											<th class="text-center">Total</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="item in reportdata?.data?.top_ten_item_ytd" :key="'ytd_'+item.ItemID">
											<td class="py-2 align-top">{{ item.ItemID }}</td>
											<td class="py-2 px-3">{{ item.ItemName }}</td>
											<td class="py-2 align-top text-right">{{ formatNum(item.Total, 0) }}</td>
										</tr>
										<!--
										<tr class="border-top">
											<td class="pt-2 fw-bold" colspan="2">Total</td>
											<td class="text-center font-weight-bold">{{ formatNum(totalPegawaiByJabatan, 0) }}</td>
										</tr>
										-->
									</tbody>
								</table>
							</div>
						</el-card>
						<Loader v-if="loading.table"/>
					</div>

					<div class="col-md-6 mb-3">
						<el-card shadow="hover">
							<div slot="header">
								<h5 class="text-center m-0 px-2">TOP 10 ITEM {{ (getMonthName(month)).toUpperCase() }} {{ year }}</h5>
							</div>
							<div>
								<table class="table-g" style="width:100%;">
									<thead>
										<tr class="border-bottom">
											<th class="pb-2">Item Id</th>
											<th class="pb-2 px-3">Item Name</th>
											<th class="text-center">Total</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="item in reportdata?.data?.top_ten_item_month" :key="'month_'+item.ItemID">
											<td class="py-2 align-top">{{ item.ItemID }}</td>
											<td class="py-2 px-3">{{ item.ItemName }}</td>
											<td class="py-2 align-top text-right">{{ formatNum(item.Total, 0) }}</td>
										</tr>
										<!--
										<tr class="border-top">
											<td class="pt-2 fw-bold" colspan="2">Total</td>
											<td class="text-center font-weight-bold">{{ formatNum(totalPegawaiByJabatan, 0) }}</td>
										</tr>
										-->
									</tbody>
								</table>
							</div>
						</el-card>
						<Loader v-if="loading.table"/>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import {Rainbow, Config, AppColors, Penanggalan, AxiosWithJar } from '@/utility.js'
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Fuel from '@/components/page/Fuel.js'
import Footer from '@/views/Footer.vue'
import PieChart from '@/components/chart/Pie.js'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import Loader from '@/components/loader/Loader2.vue'

export default{
	extends: Fuel,
	components:{
		BarChart,
		Loader,
		//ListItem,
		//ListCompare,
		//BarCard,
		//PieChart,
		//Footer
	},
	data() {
		return {
            reportdata: {},
            value: 0,
			month: Penanggalan().bulan,
			year: Penanggalan().tahun,
			chartdata: [],
			loading: {
				table: false,
				isSuccess: false,
			},
            isChildRoute: false,
		}
	},
	watch: {
        $route(to, from) {
            this.hideNonChildren();
        }
	},
	computed: {

	},

    mounted() {
        this.hideNonChildren();
		this.getData();
    },
    methods:{
        hideNonChildren() {
            this.isChildRoute = this.$route.path !== '/b2b';
        },
		async getData() {
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams += '/v1/b2b/overview?'

			//this.urlRequestParams += '&year='+this.year
			//this.urlRequestParams += '&month='+this.month

            this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					this.loading.isSuccess = true;
					this.reportdata = response.data;

                    if(this.reportdata) {
                        //default group = detail
                        let legend = 'Legend';
                        let valuecol = 'Total';
                        let label = 'MonthName';
                        this.chartdata = this.processBarChart(this.reportdata.data.monthly_transaction, legend, "", valuecol, false, label, "", 1, 2, AppColors, false, false, false, this.stacked)
                    }

				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})
        },
	}
}
</script>
